import { useContext, useState, useEffect } from 'react';
import { IdentityContext } from '../components/contexts/IdentityContext';
import SiteContext from '../components/contexts/SiteContext';
import { initializePricingContextModule } from '../apis/pricingContextApi';

const usePricingContext = () => {
  const { isIdentityInitialized } = useContext(IdentityContext);
  const { country: siteCountry, pricingOptions } = useContext(SiteContext);
  const { merchantId: pricingOptionsMerchantId = 'vistaprint' } =
    pricingOptions || {};

  const [pricingContextInitialized, setPricingContextInitialized] =
    useState(false);
  const [displayTaxInclusivePricing, setDisplayTaxInclusivePricing] =
    useState(false);

  useEffect(() => {
    const initPricingContext = () => {
      initializePricingContextModule(
        pricingOptionsMerchantId,
        siteCountry
      ).finally(() => {
        setPricingContextInitialized(true);
      });
    };

    if (isIdentityInitialized) {
      initPricingContext();
    }
  }, [isIdentityInitialized, pricingOptionsMerchantId, siteCountry]);

  return {
    pricingContextInitialized,
    displayTaxInclusivePricing,
    setDisplayTaxInclusivePricing,
  };
};

export default usePricingContext;
